import { PermissionT } from "../types";

export const cobrandingAccess = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "cobranding_access");
  return !!p;
};

export default cobrandingAccess;
